import { render, staticRenderFns } from "./ShowBarcode.vue?vue&type=template&id=58ffdba7&"
import script from "./ShowBarcode.vue?vue&type=script&lang=js&"
export * from "./ShowBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports